<template>
    <div class="content">
        <input
            ref="field_value"
            :value="counter"
            :disabled="disabled"
            type="number"
            autocomplete="off"
            :class="['input', size, selectedClass]"
            :style="{ color: inputTextColor }"
            @input="update"
			@keypress="handleKeypress"
			@blur="handleBlur"
        />
        <div>
            <span
                :class="[{ disabled: disabled }, selectedClass]"
                class="button icon-parent"
                type="button"
                @click="increment"
            >
                <ui-plus-icon />
            </span>
            <span
                :class="[{ disabled: disabled }, selectedClass]"
                class="button icon-parent"
                type="button"
                @click="decrement"
            >
                <ui-minus-icon />
            </span>
        </div>
    </div>
</template>

<script>
import { utilMixin } from '@/mixins';

export default {
	name: 'ui-input-number-stepper',

	mixins: [utilMixin],

	props: {
		/**
		 * Define o valor que vai aparecer
		 */
		value: {
			type: Number,
			required: true,
			default: 0,
		},

		/**
		 * Define o valor máximo do input
		 */
		maxValue: {
			type: Number,
			required: false,
			default: 9999999,
		},

		/**
		 * Defines a max value to the input
		 */
		minValue: {
			type: Number,
			required: false,
			default: 0,
		},
		/**
		 * Use to disable input
		 */
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		/**
		 * define a cor de texto do input
		 */
		inputTextColor: {
			type: String,
			required: false,
			default: '#172B46',
		},
    	/**
		 * define a largura do input
		 */
		size: {
			type: String,
			required: false,
			default: ''
		},
        /**
         * aceite apenas números inteiros
         */
        onlyInteger: {
            type: Boolean,
            default: false
        },
		/**
		 * define se o input irá ser focado automaticamente quando surgir no DOM
		 */
		focus: {
			type: Boolean,
			required: false,
			default: false
		},
		/**
		 * Error
		 * Adiciona uma classe error ao componente. Deixando suas bordas avermelhadas
		 */
		error: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	computed: {
		counter: {
			get() {
				if (this.value === '' || this.value === null || typeof this.value === 'undefined') {
					return ''
				}
				return this.value
			},
			set(value) {
				if (value === '' || value === null) {
					this.$emit('input', '')
				} else {
					this.$emit('input', parseInt(value))
				}
			},
		},
		selectedClass() {
			return [
				this.error ? 'error' : '',
			]
		},
	},

	watch: {
		maxValue: {
			deep: true,
			handler() {
				this.setMinMax()
			},
		},
		value: {
			deep: true,
			handler() {
				this.setMinMax()
			},
		},
	},

	mounted() {
		this.setMinMax()

		//foca automaticamente no input quando surgir no DOM
		if(this.focus) this.$refs.field_value.focus();
	},

	methods: {
			/**
			 * Verifica se o input está vazio e atribui o valor minValue
			 */
			handleBlur() {
				if (this.counter === '' || this.counter === null || typeof this.counter === 'undefined') {
					this.counter = this.minValue
				}
			},
			/**
			 * Verifica se o valor atual é maior do que o máximo, altera o valor para o
			 * valor máximo
			 */
			setMinMax() {
				if (this.value === '') return
				if (parseInt(this.value) > this.maxValue) {
					this.counter = this.maxValue
				} else if (!this.$mx_hasValue(this.value) || parseInt(this.value) < this.minValue) {
					this.counter = this.minValue
				}
			},
			/**
			 * Emits an event as soon as any change in any of the inputs occurs
			 */
			update(e) {
				const rawValue = e.target.value

				// Caso só queira número inteiro
				if (this.onlyInteger) {
					// Remove qualquer caractere que não seja dígito (0-9)
					const numericValue = rawValue.replace(/[^\d]/g, '')
					this.counter = numericValue ? parseInt(numericValue) : ''
					return
				}

				// Lógica padrão, permite ponto ou vírgula
				if (rawValue && parseInt(rawValue) >= this.maxValue) {
					e.target.value = this.maxValue
					this.counter = this.maxValue
				} else if (rawValue === "") {
					this.counter = ""
				} else {
					// Aqui ele permite número com vírgula, se você quiser adaptar mais pra aceitar float, também dá
					this.counter = parseInt(rawValue) || this.minValue
				}
			},

			handleKeypress(e) {
				if (this.onlyInteger) {
					const key = e.key
					// Permite apenas números (0 a 9)
					if (!/^\d$/.test(key)) {
						e.preventDefault()
					}
				}
			},

			async increment() {
				if (this.disabled || this.counter >= this.maxValue) return

				this.counter++
				await this.$nextTick()
			},

			async decrement() {
				if (this.disabled || this.counter <= this.minValue) return

				this.counter--
				await this.$nextTick()
			},
		},
}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>